import * as React from "react";
import Page from "../components/layout/page";

function Contact() {
  return <Page>Contact</Page>;
}

export default Contact;
